'use client';

import { useScrollToTop } from '../../hooks/useScrollToTop';

/**
 * Component that scrolls to the top of the page when the route changes.
 * Add this component to your root layout to ensure pages load at the top
 * when navigating between routes in Next.js App Router.
 */
export function ScrollToTop() {
    useScrollToTop({});
    return null;
}
